import { getDate, endOfMonth, setDate } from "date-fns";

/**
 * 月末を丸めて日にちを設定する
 */
export default function setDayOfMonth(month: Date, dayOfMonth: number): Date {
  const d = Math.min(dayOfMonth, getDate(endOfMonth(month)));
  return setDate(month, d);
}
